export default __webpack_public_path__ + "static/error404-0989d5dd8405861bd5bc9b96df4810d0.webp";